export default "__VITE_ASSET__14e2a244__"